import React from 'react';
export const Results = () => {
  const performanceData = [{
    year: '2020',
    return: '18.5%',
    benchmark: '8.2%'
  }, {
    year: '2021',
    return: '22.3%',
    benchmark: '12.7%'
  }, {
    year: '2022',
    return: '15.6%',
    benchmark: '-4.3%'
  }, {
    year: '2023',
    return: '19.8%',
    benchmark: '10.1%'
  }];
  return <section id="results" className="py-16 bg-gray-50 w-full" data-id="element-163">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-164">
        <div className="text-center mb-12" data-id="element-165">
          <h2 className="text-3xl font-bold text-gray-900" data-id="element-166">业绩展示</h2>
          <p className="mt-4 text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-167">
            我们的量化交易策略在各种市场环境下都能表现出色，为客户带来持续稳定的回报。
          </p>
        </div>
        <div className="bg-white rounded-xl shadow-lg overflow-hidden" data-id="element-168">
          <div className="p-6" data-id="element-169">
            <h3 className="text-xl font-semibold text-gray-900 mb-4" data-id="element-170">
              策略年度表现
            </h3>
            <div className="overflow-x-auto" data-id="element-171">
              <table className="min-w-full divide-y divide-gray-200" data-id="element-172">
                <thead data-id="element-173">
                  <tr data-id="element-174">
                    <th className="px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-175">
                      年份
                    </th>
                    <th className="px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-176">
                      极客quant策略
                    </th>
                    <th className="px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-177">
                      基准指数
                    </th>
                    <th className="px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-178">
                      超额收益
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200" data-id="element-179">
                  {performanceData.map((item, index) => {
                  const excess = (parseFloat(item.return) - parseFloat(item.benchmark)).toFixed(1) + '%';
                  return <tr key={index} data-id="element-180">
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-181">
                          {item.year}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-green-600 font-semibold" data-id="element-182">
                          {item.return}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700" data-id="element-183">
                          {item.benchmark}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-blue-600 font-semibold" data-id="element-184">
                          {excess}
                        </td>
                      </tr>;
                })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-185">
          <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-186">
            <div className="text-4xl font-bold text-blue-600 mb-2" data-id="element-187">85%</div>
            <div className="text-xl font-semibold text-gray-800 mb-2" data-id="element-188">胜率</div>
            <p className="text-gray-600" data-id="element-189">
              我们的策略在大多数交易周期中实现盈利，显著高于市场平均水平。
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-190">
            <div className="text-4xl font-bold text-blue-600 mb-2" data-id="element-191">0.92</div>
            <div className="text-xl font-semibold text-gray-800 mb-2" data-id="element-192">
              夏普比率
            </div>
            <p className="text-gray-600" data-id="element-193">
              优秀的风险调整后收益表现，为投资者提供更好的风险回报比。
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-194">
            <div className="text-4xl font-bold text-blue-600 mb-2" data-id="element-195">12.8%</div>
            <div className="text-xl font-semibold text-gray-800 mb-2" data-id="element-196">
              年化超额收益
            </div>
            <p className="text-gray-600" data-id="element-197">
              相比市场基准，我们的策略长期提供显著的超额收益。
            </p>
          </div>
        </div>
      </div>
    </section>;
};